import React from 'react';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { formatPositiveAmount } from 'src/utils/formatAmout';
import selectFormatDate from 'src/utils/selectDateFormat';
import dateFormatType from 'src/utils/dateFormatType';
import OverflowTipography from 'src/components/OverflowTipography';

const PartialReportDetailRow = ({ contract, metrics }) => {
  const { t } = useTranslation();

  return (
    <TableRow hover>
      <TableCell align="center">
        {contract?.folio ? (
          <Link to={`/contracts/${contract.id}`}>{contract.folio}</Link>
        ) : (
          t('COMMON.NO_DATA')
        )}
      </TableCell>
      <TableCell align="left">
        {contract?.clientName ? (
          <Link to={`/clients/detail/${contract.clientId}`}>
            <OverflowTipography maxWidth="160px">
              {contract.clientName}
            </OverflowTipography>
          </Link>
        ) : (
          t('COMMON.NO_DATA')
        )}
      </TableCell>
      <TableCell align="center">
        {formatPositiveAmount(metrics?.currentBalance || 0)}
      </TableCell>
      <TableCell align="center">
        {formatPositiveAmount(metrics?.overdueBalance || 0)}
      </TableCell>
      <TableCell align="center">
        {formatPositiveAmount(metrics?.lastPaymentAmount || 0)}
      </TableCell>
      <TableCell align="center">
        {metrics?.lastPaymentDate
          ? selectFormatDate(metrics?.lastPaymentDate, dateFormatType.DAY)
          : t('COMMON.NO_DATA')}
      </TableCell>
    </TableRow>
  );
};

PartialReportDetailRow.propTypes = {
  contract: PropTypes.shape({
    id: PropTypes.number,
    folio: PropTypes.string,
    clientId: PropTypes.number,
    clientName: PropTypes.string
  }),
  metrics: PropTypes.shape({
    currentBalance: PropTypes.number,
    overdueBalance: PropTypes.number,
    lastPaymentAmount: PropTypes.number,
    lastPaymentDate: PropTypes.string
  })
};

export default PartialReportDetailRow;
